export var Address = function(addressData) {
    var address = {};
    
    // Constructor
    if (addressData) {
        address.line1 = addressData.line1;
        address.line2 = addressData.line2;
        address.city = addressData.city;
        address.district = addressData.district;
        address.region = addressData.region;
        address.postalCode = addressData.postalCode;
        address.country = addressData.country;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return address;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/address.js
// module id = 194
// module chunks = 0